import { render, staticRenderFns } from "./PriceCategoryList.vue?vue&type=template&id=3ea5cf6f"
import script from "./PriceCategoryList.vue?vue&type=script&lang=js"
export * from "./PriceCategoryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports